import { canEditByRole, RolesEnum } from '$Externals/VerifyRole';
import { ConfigService, IConfigServiceInjectedProps } from '$State/ConfigFreezerService';
import { IVideoEventServiceInjectedProps, VideoEventService } from '$State/VideoEventFreezerService';
import { useVideoPlayerSync } from '$State/VideoPlayerSync/VideoPlayerSyncContext';
import { React } from 'Imports';
import { useRef, useState } from 'react';
import * as scssStyles from '$CSS/settings.scss';
import { FileUploadTypeEnum } from '$Generated/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/pro-solid-svg-icons';
import { ConfirmDialog } from '$Components/Shared/ConfirmDialog';

const styles = require('../VideoPlayer.scss') as {
    downloadControl: string;
    downloadButton: string;
};

interface IVideoDownloadControlProps {
    videoUrl: string;
    videoType: FileUploadTypeEnum;
    channelNumber?: number;
    onVideoDownloaded?: () => void;
}

type VideoDownloadControlProps = IVideoDownloadControlProps & IVideoEventServiceInjectedProps & IConfigServiceInjectedProps;

const _VideoDownloadControl = (props: VideoDownloadControlProps) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const hasRoleToDownload = canEditByRole([RolesEnum.videoAdmin]);
    const { videoEventId } = useVideoPlayerSync();
    const videoDownloadRef = useRef<HTMLAnchorElement>(null);

    const isEncompass = scssStyles.styleEnvironment === 'encompass';
    const acceptButton = isEncompass ? 'Yes, Download' : 'Download';
    const cancelButton = isEncompass ? 'No, Go back' : 'Cancel';
    const title = isEncompass ? 'Download Video' : 'Confirm Download';

    const handleDownloadVideo = async () => {
        if (videoDownloadRef.current && hasRoleToDownload) {
            videoDownloadRef.current.click();
            await props.videoEvents.downloadVideoEvent(videoEventId, props.videoType, props.channelNumber);
            if (props.onVideoDownloaded) {
                props.onVideoDownloaded();
            }
            setIsDialogOpen(false);
        }
    };

    return (
        hasRoleToDownload && (
            <div>
                <a
                    hidden
                    target="_blank"
                    rel="noreferrer"
                    href={props.videoUrl}
                    download={true}
                    onClick={(e) => e.stopPropagation()}
                    ref={videoDownloadRef}
                />
                <div className={styles.downloadControl}>
                    <FontAwesomeIcon
                        className={styles.downloadButton}
                        icon={faDownload}
                        title="Download Video"
                        onClick={() => setIsDialogOpen(true)}
                    />
                </div>
                <ConfirmDialog
                    isOpen={isDialogOpen}
                    title={title}
                    contentMessage={'Are you sure you want to download this video?'}
                    cancelButton={cancelButton}
                    acceptButton={acceptButton}
                    handleModalClosed={() => setIsDialogOpen(false)}
                    handleSubmit={handleDownloadVideo}
                    isButtonAlert={false}
                />
            </div>
        )
    );
};

export default VideoEventService.inject(ConfigService.inject(_VideoDownloadControl));
